
let addWave = function (tinymce) {
  (function () {
    'use strict'

    let global = tinymce.util.Tools.resolve('tinymce.PluginManager')

    let doAddWave = function (editor) {
      let text = editor.selection.getContent()
      let block = editor.selection.getNode();
      let blockHTML = block.outerHTML;
      let act = '';
      if (act === '') {
        act = editor.dom.getAttrib(block, 'class') === 'wave' ? 'remove' : 'add'
      }
      if (act === 'add') {
        // 先清理wave，然后一起加wave
        text = text.replace(/<bdo class="wave">(.*?)<\/bdo>/g, "$1");
        let insertText = '<bdo class="wave">' + text + '</bdo>'
        editor.selection.setContent(insertText)
      }
      // 针对波浪线中间去掉一部分或全部
      // else {
      //   // 先清理wave，然后一起加wave
      //   blockHTML = blockHTML.replace(/<span class="wave">(.*?)<\/span>/g, "$1");
      //   let all = blockHTML.length;
      //   let start = blockHTML.indexOf(text);
      //   let end = start + text.length;
      //   if (start === 0) {
      //     blockHTML = blockHTML.substring(0, end) + '<span class="wave">' + blockHTML.substring(end) + '</span>'
      //   }
      //   else if (end === all) {
      //     blockHTML = blockHTML.substring(0, start) + '<span class="wave">' + blockHTML.substring(start, end) + '</span>'
      //   }
      //   else {
      //     blockHTML = '<span class="wave">' + blockHTML.substring(0, start) + '</span>'
      //       + blockHTML.substring(start, end)
      //       + '<span class="wave">' + blockHTML.substring(end, all) + '</span>';
      //   }
      //   editor.dom.setOuterHTML(block, blockHTML)
      // }
    }

    let register = function (editor) {
      editor.addCommand('doAddWave', function () {
        doAddWave(editor)
      })

      editor.addButton('addWave', {
        tooltip: '添加波浪线',
        image: 'https://jty-open-new.obs.cn-north-4.myhuaweicloud.com/2024/2024-9-9/1725870560567otrdfy835o.png',
        icon: false,
        cmd: 'doAddWave'
      })

      editor.addMenuItem('addWave', {
        text: '添加波浪线',
        image: 'https://jty-open-new.obs.cn-north-4.myhuaweicloud.com/2024/2024-9-9/1725870560567otrdfy835o.png',
        icon: false,
        cmd: 'doAddWave'
      })
    }

    global.add('addWave', function (editor) {
      register(editor)
    })

    function Plugin () {}

    return Plugin
  })()
}

export default addWave



// WEBPACK FOOTER //
// ./src/components/editor4/tinymce/plugins/addWave/index.js